import React, { type ReactElement } from 'react';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/DocumentTitle.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { insightObjectResource } from '@atlassian/jira-router-resources-servicedesk-cmdb-object/src/services/index.tsx';
import type { InsightObjectDetailsResponse } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-details.tsx';
import {
	type CmdbObjectId,
	toCmdbObjectId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import { GenericError } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/errors/index.tsx';
import { InsightObjectViewSkeleton } from '@atlassian/jira-skeletons/src/ui/insight-object/InsightObjectViewSkeleton.tsx';
import { usePathParam, useResource } from '@atlassian/react-resource-router';
import messages from './messages.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { FullPageObjectViewWrapper } from './styled';

type Props = {
	children: (arg1: {
		prefetchData: InsightObjectDetailsResponse;
		objectId: CmdbObjectId;
	}) => ReactElement;
};

export const InsightObjectViewPageContainer = (props: Props) => {
	const { formatMessage } = useIntl();

	const {
		data: objectDetails,
		loading,
		error,
	} = useResource<InsightObjectDetailsResponse | null>(insightObjectResource);

	const [objectId] = usePathParam('objectId');

	if (loading) {
		return <InsightObjectViewSkeleton />;
	}

	if (error) {
		return <GenericError />;
	}

	return objectDetails && objectId != null ? (
		<>
			<DocumentTitle
				title={formatMessage(messages.documentTitleCmdbAssets, {
					objectKey: objectDetails.objectKey,
					objectName: objectDetails.label,
				})}
			/>
			{props.children({
				prefetchData: objectDetails,
				objectId: toCmdbObjectId(objectId),
			})}
		</>
	) : (
		<InsightObjectViewSkeleton />
	);
};
